module.exports = __webpack_public_path__ + "static/media/sign_up_step_1.80699231.svg";